<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-8 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('user.User_info')" :class="activeStep >= 0 ? activeClass : ''">
                                                <span>{{ $t('user.User_info') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('user.Password')"
                                                :class="activeStep >= 1 ? activeClass : ''">
                                                {{ $t('user.Password') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" title="$t('user.Address')"
                                                :class="activeStep >= 2 ? activeClass : ''">
                                                {{ $t('user.Address') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" title="$t('user.Image')"
                                                :class="activeStep >= 3 ? activeClass : ''">
                                                {{ $t('user.Image') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <user-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep" 
                                            :roles="formData.roles"
                                            :inspectors="formData.inspectors"
                                            ref="signimageSection"
                                            :emitter="emitter"
                                            @update:formData="updateFormData"
                                        />
                                        <Password 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <Address 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <Image 
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            :formData="formData"
                                            ref="profileimageSection"
                                            :emitter="emitter"
                                        />                                        
                                        <div class="button-row d-flex">
                                            <button v-if="activeStep === 3" @click="saveForm" class="btn mb-0 btn-sm bg-gradient-success null null ms-auto" type="button">{{ $t('common.Save') }}</button>
                                        </div>                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'
import * as Choices from "choices.js";
import UserInfo from "./components/UserInfo.vue";
import Address from "./components/Address.vue";
import Image from "./components/Image.vue";
import Password from "./components/Password.vue";
import mitt from 'mitt';

    export default {
        name: 'User_create_page',
        data() {
            return {
                emitter: mitt(),
                activeStep: 0,
                activeClass: "js-active position-relative",
                formSteps: 4,
                formData: {
                    initials: '',
                    //prefix: '',
                    firstName: '',
                    lastName: '',
                    mobileNumber: '',
                    password: '',
                    email: '',
                    phoneNumber: '',
                    inspectorId: '',
                    associationId: '',
                    address: '',
                    houseNumber: '',
                    city: '',
                    zipcode: '',
                    country: 'Nederland',
                    shareTelephone: true,
                    shareAddress: true,
                    shareEmail: true,
                    shareName: true,
                    rvoConnection: false,
                    rvoRelationnumber: '',
                    gdConnection: false,
                    studbookCode: '',
                    userStartDate: null,
                    userEndDate: null,                    
                    roleId: '',
                    roleName: '',
                    image: null,
                    roles:[],
                    inspectors:[],                    
                    profileImage: null,
                    signatureImage: null,                    
                },
                choicesInstance: null // Store Choices instance
            };
        },
        computed: {
            userRoleName() {
                return this.$store.state.user?.roleName;
            }            
        },
        components: {
            UserInfo,
            Password,
            Address,
            Image
        },    
        async mounted() { 

            this.associationId = this.$route.params.id;

            await this.fetchAllRoleData();
            //this.initializeChoicesRole();

            await this.fetchAllInspectorData();
            //this.initializeChoicesInspector();

            // Set up listeners once
            this.emitter.on('signImageUploaded', this.handleSignatureImageUploaded);
            this.emitter.on('profileImageUploaded', this.handleProfileImageUploaded);
        },
        methods: {            
            async nextStep() {                
                if (this.activeStep < this.formSteps -1) {
                    this.activeStep += 1;
                    //console.log(this.activeStep);
                } else {
                    this.activeStep -= 1;
                    //console.log(this.activeStep);
                }   
                
                if(this.activeStep == 0) {
                    await this.fetchAllRoleData();                    
                }
            },
            async prevStep() {
                if (this.activeStep > 0) {
                    this.activeStep -= 1;
                    //console.log(this.activeStep);

                    if(this.activeStep == 0) {
                        await this.fetchAllRoleData();                        
                        if(this.formData.roleId == 'Keeper')
                        {
                            await this.fetchAllInspectorData();                            
                        }
                    }
                }
            },
            async fetchAllRoleData() {
                try {
                    let response;
                    
                    if (this.userRoleName === 'Admin') {
                        response = await axios.get("auth/getroles");
                    } else {
                        response = await axios.get("auth/getassociationadminroles");
                    }                    
                    const result = response.data;

                    if (result.success && Array.isArray(result.data.roleList)) {
                        this.formData.roles = result.data.roleList;

                        // Wait for DOM to update
                        this.$nextTick(() => {
                            this.initializeChoicesRole(); // Initialize Choices here
                        });
                    } else {
                        this.$showError('errors.Error_fetching_roles');
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },            
            initializeChoicesRole() {
                const element = document.getElementById("roleId");

                if (!element || element.tagName !== "SELECT") {
                    console.error("Choices: Invalid or missing select element.");
                    return;
                }

                if (this.choicesInstanceRole) {
                    this.choicesInstanceRole.destroy();
                }
                
                this.choicesInstanceRole = new Choices(element, {
                    searchEnabled: true,
                    itemSelectText: '',
                    shouldSort: false,
                    placeholder: true, 
                    //placeholderValue: '-- Select role --', 
                });        
                
                if (this.formData.roleId) {
                    const optionExists = this.formData.roles.some(role => role.name === this.formData.roleId);
                    if (optionExists) {
                        this.choicesInstanceRole.setChoiceByValue([this.formData.roleId]); // Set the selected value
                    } else {
                        this.choicesInstanceRole.setChoiceByValue(''); // Clear if no match found
                    }
                }
            },
            async fetchAllInspectorData() {
                try {
                    const response = await axios.get("user/getbyassociation", {
                        params: {
                            associationId: this.associationId,
                            role: 'Inspector'                            
                        }
                    });                    
                    const result = response.data;

                    if (result.success && Array.isArray(result.data.userList)) {
                        this.formData.inspectors = result.data.userList;

                        // Wait for DOM to update
                        this.$nextTick(() => {
                            this.initializeChoicesInspector(); // Initialize Choices here
                        });
                    } else {
                        this.$showError('errors.Error_fetching_inspectors');                        
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },
            initializeChoicesInspector() {
                const element = document.getElementById("inspectorId");

                if (!element || element.tagName !== "SELECT") {
                    console.error("Choices: Invalid or missing select element.");
                    return;
                }

                if (this.choicesInstanceInspector) {
                    this.choicesInstanceInspector.destroy();
                }
                
                this.choicesInstanceInspector = new Choices(element, {
                    searchEnabled: true,
                    itemSelectText: '',
                    shouldSort: false,
                    placeholder: true, 
                    //placeholderValue: '-- Select inspector --', 
                });                        
                if (this.formData.inspectorId) {
                    const optionExists = this.formData.inspectors.some(inspector => inspector.id === this.formData.inspectorId);
                    if (optionExists) {
                        this.choicesInstanceInspector.setChoiceByValue([this.formData.inspectorId]); // Set the selected value
                    } else {
                        this.choicesInstanceInspector.setChoiceByValue(''); // Clear if no match found
                    }
                }
            },            
            updateFormData(updatedData) {
                this.formData = { ...this.formData, ...updatedData };                
            },
            handleProfileImageUploaded(file) {
                console.log('Signature image received');
                if (file instanceof File || typeof file === 'string') {
                    console.log('profilefile');
                    this.formData.profileImage = file;
                }
            },
            handleSignatureImageUploaded(file) {
                console.log('Signature image received');
                if (file instanceof File || typeof file === 'string') {
                    console.log('Signature image received:', file);
                    this.formData.signatureImage = file;
                }
            },
            async uploadImageIfQueued(ref, imageKey) {
                if (ref?.getQueuedFiles?.().length > 0) {
                    const previousFile = this.formData[imageKey];

                    await new Promise((resolve) => {
                    const checkInterval = setInterval(() => {
                        if (this.formData[imageKey] !== previousFile && this.formData[imageKey] != null) {
                        clearInterval(checkInterval);
                        resolve();
                        }
                    }, 100);
                    ref.processQueue();
                    });
                }
            },
            async saveForm() {
                
                await this.uploadImageIfQueued(this.$refs.profileimageSection, 'profileImage');
                await this.uploadImageIfQueued(this.$refs.signimageSection, 'signatureImage');

                console.log("profileImage:", this.formData.profileImage);
                console.log("signatureImage:", this.formData.signatureImage);

                this.submitForm();
            },           
            async submitForm() {                
                try {
                    this.$store.commit('setShowLoading', true);

                    const formData = new FormData();

                    if (this.userRoleName == 'Admin') {
                        this.formData.associationId = this.associationId;
                    } if (this.userRoleName == 'AssociationAdmin') {
                        this.formData.associationId = this.associationId;
                    }
                    
                    Object.keys(this.formData).forEach(key => {
                        // Skip 'confirmPassword' field
                        if (key !== 'confirmPassword') {
                            const value = this.formData[key];

                            if (key === 'roleId' && this.formData.roleId) {
                                this.formData.roleName = this.formData.roleId;  // Set roleName to the value of roleId
                            }

                            if ((key === 'profileImage' || key === 'signatureImage') && value instanceof File) {
                                formData.append(key, value);
                            } else if (value !== null && value !== undefined) {
                                formData.append(key, value);
                            }
                        }
                    });
                                        
                    // Send data to the server
                    await axios.post('/auth/registeruser', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        // Handle success
                        //console.log('Form saved successfully', response.data);
                        this.gets = response.data;
                        if (this.gets.success) {                            
                            this.$showSuccess('errors.Success_user_created_successfully');
                            this.$router.push('/user');
                        } else {
                            this.$showError('errors.Contact_system_admin');
                        }
                    });
                }
                catch(e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
                
                this.$store.commit('setShowLoading', false);
            }
        },
    }
</script>

<style>

.multisteps-form__progress-btn {
  cursor: default !important; /* removes the hand icon */
}

.choices[data-type*=select-one]::after {
  display: none !important;
}


.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}


.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}
</style>

